import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "draft-tree" }
const _hoisted_2 = { class: "d-flex align-items-center gap-2 flex-wrap mb-2" }
const _hoisted_3 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_4 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "text-muted small" }
const _hoisted_8 = { class: "dt-passups" }
const _hoisted_9 = { class: "dt-legend text-muted small ms-auto" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger py-1 px-2 small mb-2"
}
const _hoisted_11 = { class: "dt-chart" }
const _hoisted_12 = {
  key: 0,
  class: "dt-detached"
}
const _hoisted_13 = { class: "dt-detached-title" }
const _hoisted_14 = { class: "dt-chart" }
const _hoisted_15 = {
  key: 1,
  class: "small text-muted mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draft_tree_subtree = _resolveComponent("draft-tree-subtree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.expandAll && _ctx.expandAll(...args)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
          _createTextVNode(" Expandir todo ", -1)
        ]))]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.collapseAll && _ctx.collapseAll(...args)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "fas fa-minus" }, null, -1),
          _createTextVNode(" Colapsar todo ", -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          title: "Más pequeño",
          disabled: _ctx.zoom === 0,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.zoomBy(-1)))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "fas fa-magnifying-glass-minus" }, null, -1)
        ]))], 8, _hoisted_5),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          title: "Más grande",
          disabled: _ctx.zoom === _ctx.ZOOMS.length - 1,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoomBy(1)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "fas fa-magnifying-glass-plus" }, null, -1)
        ]))], 8, _hoisted_6)
      ]),
      _createElementVNode("span", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.forest.drawn) + " de " + _toDisplayString(_ctx.forest.total) + " nodos · " + _toDisplayString(_ctx.forest.maxDepth) + " niveles ", 1),
        (_ctx.forest.mode === 'cmmi')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[8] || (_cache[8] = _createTextVNode(" · ", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.forest.passUps) + " " + _toDisplayString(_ctx.forest.passUps === 1 ? "pase" : "pases"), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_9, [
        (_ctx.mode === 'binary')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dt-key dt-key-l" }, "I", -1)),
              _cache[10] || (_cache[10] = _createTextVNode(" izquierda ", -1)),
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "dt-key dt-key-r" }, "D", -1)),
              _cache[12] || (_cache[12] = _createTextVNode(" derecha · ", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "dt-key dt-key-a" }, [
                _createElementVNode("i", { class: "fas fa-anchor" })
              ], -1)),
              _cache[14] || (_cache[14] = _createTextVNode(" ancla · el recuadro punteado es una pierna libre · ", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("strong", null, "«de:»", -1)),
              _cache[16] || (_cache[16] = _createTextVNode(" es el patrocinador ", -1))
            ], 64))
          : (_ctx.mode === 'unilevel')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "dt-key dt-key-l" }, "I", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "dt-key dt-key-r" }, "D", -1)),
                _cache[19] || (_cache[19] = _createTextVNode(" pierna del patrocinador a la que le suman los puntos · ", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "dt-key dt-key-a" }, [
                  _createElementVNode("i", { class: "fas fa-anchor" })
                ], -1)),
                _cache[21] || (_cache[21] = _createTextVNode(" ancla · aquí cada uno cuelga de quien lo patrocina ", -1))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "dt-key dt-key-p" }, [
                  _createElementVNode("i", { class: "fas fa-arrow-up" })
                ], -1)),
                _cache[23] || (_cache[23] = _createElementVNode("strong", null, "pase", -1)),
                _cache[24] || (_cache[24] = _createTextVNode(": no cuelga de quien lo patrocinó — su patrocinador no calificaba y subió a alguien de más arriba · ", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("strong", null, "«antes:»", -1)),
                _cache[26] || (_cache[26] = _createTextVNode(" es dónde colgaba en el CMMI viejo ", -1))
              ], 64))
      ])
    ]),
    (_ctx.forest.duplicateLegs.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
          _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Dos nodos en la misma pierna", -1)),
          _createTextVNode(" — " + _toDisplayString(_ctx.forest.duplicateLegs.join(" · ")), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "dt-scroll",
      style: _normalizeStyle({ fontSize: _ctx.ZOOMS[_ctx.zoom] + 'px' })
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_draft_tree_subtree, {
          item: _ctx.forest.root,
          mode: _ctx.mode
        }, null, 8, ["item", "mode"])
      ]),
      (_ctx.forest.detached.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-unlink" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.forest.detached.length) + " " + _toDisplayString(_ctx.forest.detached.length === 1 ? "rama suelta" : "ramas sueltas") + " — su padre no está en el draft (o la cadena se muerde la cola) ", 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forest.detached, (item) => {
                return (_openBlock(), _createBlock(_component_draft_tree_subtree, {
                  key: item.username,
                  item: item,
                  mode: _ctx.mode
                }, null, 8, ["item", "mode"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4),
    (_ctx.forest.offTree.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.forest.offTree.length) + " fuera del binario", 1),
          _cache[30] || (_cache[30] = _createTextVNode(" (sólo unilevel, no ocupan pierna): ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forest.offTree, (node) => {
            return (_openBlock(), _createElementBlock("code", {
              key: node.username,
              class: "me-2"
            }, _toDisplayString(node.label), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}